import {
    UPDATE_SLIDER_START,
    UPDATE_SLIDER_SUCCESS,
    UPDATE_SLIDER_FAIL,
} from './ActionsTypes';
// alerts
import Swal from 'sweetalert2';
// axios
import clienteAxios from '../../config/Axios';

export function UpdateSliderAction(data, navigate, token, id) {
    return (dispatch) => {
        dispatch(UpdateSliderStart())

        const config = { headers: { 'Authorization': "Bearer " + token } };//confi axios

        clienteAxios.put(`/api/sliders/update-slider/${id}`, data, config)
            .then((res) => {
                // console.log(res.data)
                Swal.fire({ icon: 'success', title: 'Exito', text: 'Slider actualizado' })
                dispatch(UpdateSliderSuccess())
            })
            .catch(error => {
                dispatch(UpdateSliderFail())
                console.log(error.response)
                if (!error.response) {
                    Swal.fire({ icon: 'error', title: 'Lo siento', text: 'Error de conexión.' })
                } else if (error.response.status === 400) {
                    Swal.fire({ icon: 'error', title: 'Lo siento', text: 'Datos invalidos' })
                } else {
                    Swal.fire({ icon: 'error', title: 'Lo siento', text: 'Error, intente de nuevo' })
                }
            })
    }
}



export const UpdateSliderStart = () => {
    return {
        type: UPDATE_SLIDER_START
    };
};

export const UpdateSliderSuccess = () => ({
    type: UPDATE_SLIDER_SUCCESS
})

export const UpdateSliderFail = () => ({
    type: UPDATE_SLIDER_FAIL,
})
